import TrafficChangesPeriod from "../models/traffic/TrafficChangesPeriod";

export const TOOLTIP_ITEMS_LIMIT = 5;

export const TOOLTIP_ITEMS_LIMIT_SMALL_SCREEN = 3;

export const TRAFFIC_PERIOD_SHORT = {
    [TrafficChangesPeriod.MonthOverMonth]: "1m",
    [TrafficChangesPeriod.QuoterOverQuoter]: "3m",
    [TrafficChangesPeriod.YearOverYear]: "12m",
};